import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


const __default__ = {
  name: 'TitleBar'
};

import {withDefaults} from 'vue';
import {NavBar} from 'vant';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    noticeBarHeight: { default: '0px' },
    title: { default: '' },
    backgroundColor: { default: '#fff' },
    position: { default: 'sticky' },
    isBrowerOpen: { type: Boolean }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "5a0e2db1": (__props.position),
  "fe2e44cc": (__props.noticeBarHeight),
  "6c6db94d": (__props.backgroundColor)
}))



return (_ctx: any,_cache: any) => {
  return (!__props.isBrowerOpen)
    ? (_openBlock(), _createBlock(_unref(NavBar), {
        key: 0,
        title: __props.title,
        class: "title-bar"
      }, {
        left: _withCtx(() => [
          _renderSlot(_ctx.$slots, "left")
        ]),
        right: _withCtx(() => [
          _renderSlot(_ctx.$slots, "right")
        ]),
        _: 3
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}
}

})